import StandaloneProducts from './WebsiteStandaloneProducts';

export default StandaloneProducts;
